import { useDispatch, useSelector } from 'react-redux';

import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import ListItemText from '@mui/material/ListItemText';
import ListItemAvatar from '@mui/material/ListItemAvatar';
import ListItemButton from '@mui/material/ListItemButton';

import { useRouter } from 'src/routes/hooks';

import { user_readUserNotificationFunc } from 'src/context/notifications/user_readUserNotification';

import { Iconify } from 'src/components/iconify';

// ----------------------------------------------------------------------

export type INotificationItem = {
  _id: string;
  createdAt: string;
  isRead: boolean;
  user: {
    _id: string;
    displayImage: string;
    displayName: string;
  };
  updatedAt: string;
  uid: string;
  notificationType: string;
  notificationPreview: {
    content: string;
    data: {
      target: string;
      targetId: string;
      uid: string;
    };
    name: string;
    subject: string;
  };
};

export type NotificationItemProps = {
  notification: INotificationItem;
};

export function NotificationItem(props: NotificationItemProps) {
  const router = useRouter();
  const dispatch = useDispatch();
  const userActivityConversations = useSelector((state: any) => state.userActivityConversations);
  const { userData } = useSelector((state: any) => state.user);
  const user_id = userData?._id;

  const handleNotificationClick = () => {
    
    // Bildirim verisinden uid'yi al
    const notificationUid = props.notification?.uid; // Bildirimi okundu işaretlemek için
    const dataUid = props.notification?.notificationPreview?.data?.uid; // Conversation identifier
    const targetId = props.notification?.notificationPreview?.data?.targetId;
    // Bildirimi okundu olarak işaretle
    if (notificationUid && dispatch) {
      dispatch(user_readUserNotificationFunc({ uid: notificationUid }));
    }

    if (dataUid) {
      let activityId = targetId;
      let receiverId = null;

      // targetId yoksa conversation list'ten bul
      if (!activityId && userActivityConversations?.userActivityConversationsData?.data) {
        
        const conversations = userActivityConversations.userActivityConversationsData.data;

        // Yöntem 1: dataUid'yi conversation'larda direkt ara (önceki deneme)
        let matchingConversation = conversations.find((conversation: any) => {
          const receiverMatch = conversation?.receiver?._id === dataUid;
          const moderatorMatch = conversation?.activity?.exteriorOrganizer?._id === dataUid;
          return receiverMatch || moderatorMatch;
        });

        // Yöntem 2: dataUid eşleşmezse, user'ın kendi ID'si ile conversation bul
        if (!matchingConversation) {
          
          // Notification content'inden aktivite adını çıkar
          const notificationContent = props.notification?.notificationPreview?.content || '';
          
          // "X adlı aktivitenizde" pattern'ini ara
          const activityNameMatch = notificationContent.match(/(.+?) adlı aktivitenizde/);
          const activityName = activityNameMatch ? activityNameMatch[1].trim() : null;
          
          // Aktivite adına göre direkt conversation bul (user ID kontrolü yok)
          if (activityName) {
            matchingConversation = conversations.find((conversation: any) => {
              const titleMatch = conversation?.activity?.title?.includes(activityName);
              return titleMatch;
            });
            
          }
          
          // Aktivite adı bulunamazsa, ilk conversation'ı kullan
          if (!matchingConversation && conversations.length > 0) {
            matchingConversation = conversations[0];
          }
        }

        if (matchingConversation) {
          activityId = matchingConversation.activity?.activityId?._id;

          // Kullanıcının role'üne göre receiverId'yi belirle
          if (matchingConversation.receiver?.role === 'moderator') {
            receiverId = matchingConversation.receiver?._id;
          } else {
            // Parent ise, moderator ile konuşuyor
            receiverId =
              matchingConversation.activity?.exteriorOrganizer?._id ||
              matchingConversation.receiver?._id;
          }
          
        }
      }

      if (activityId && receiverId) {
        // Direkt hash'li URL'ye git (timing sorunu için)
        const targetHash = `/mesajlar?activityId=${activityId}&&receiverId=${receiverId}`;

        // Eğer zaten messages sayfasındaysak, sadece hash'i değiştir
        if (window.location.pathname === '/messages') {
          window.location.hash = targetHash;
        } else {
          // Başka bir sayfadaysak, tam URL ile git
          window.location.href = `/messages#${targetHash}`;
        }
        
      

      } else {
        router.push('/messages');
      }
    } else {
      router.push('/messages');
    }
  };

  const renderAvatar = () => (
    <ListItemAvatar>
      {/* {props.notification.user && (
        <Avatar src={props.notification.user.displayImage} sx={{ bgcolor: 'secondary.main' }} />
      )} */}
      <Iconify icon="mdi:bell" sx={{ fontSize: 24 }} />
    </ListItemAvatar>
  );

  const renderText = () => (
    <ListItemText
      disableTypography
      primary={
        <Typography variant="body1" fontWeight={600}>
          {props.notification?.notificationPreview?.content}
        </Typography>
      }
      // secondary={
      //   <Typography variant="caption">
      //     {props.notification?.notificationPreview?.content}
      //   </Typography>
      // }
    />
  );

  const renderUnReadBadge = () =>
    !props.notification.isRead && (
      <Box
        sx={{
          top: 26,
          width: 8,
          height: 8,
          right: 20,
          borderRadius: '50%',
          bgcolor: 'info.main',
          position: 'absolute',
        }}
      />
    );

  return (
    <ListItemButton
      disableRipple
      onClick={handleNotificationClick}
      sx={[
        (theme) => ({
          p: 2.5,
          alignItems: 'center',
          borderBottom: `dashed 1px ${theme.vars.palette.divider}`,
          cursor: 'pointer',
        }),
      ]}
    >
      {renderUnReadBadge()}
      {renderAvatar()}

      <Box sx={{ flex: '1 1 auto' }}>{renderText()}</Box>
    </ListItemButton>
  );
}
